<template>
  <v-layout row wrap>
    <v-expansion-panel style="border:#EEE 1px solid; box-shadow:none !important">
      <v-expansion-panel-content>
        <template v-slot:header>
          <div class="caption blue--text" style="margin-left: -10px; margin-right:-10px">
            <v-icon flat class="blue--text" style="font-size:18px;">filter_list</v-icon>
            {{ $t('datatable-advanced-search') }}
          </div>
        </template>
        <v-card>
          <v-card-text>
            <slot name="form" />
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-layout>
</template>

<script>
export default {
  name: 'dt-advanced-search'

  // props: {
  //   search: { type: String, required: false }
  // },

  // methods: {
  //   inputChanged (event) {
  //     this.$emit('typing', event)
  //   }
  // },
  // updated () {
  //   document.addEventListener('keyup', (e) => {
  //     // if the "ESC" button was pressed and this dialog is shown, hide it
  //     if (e.keyCode === 27 && this.deleteDialog) {
  //       // console.log('ESC button pressed from the delete modal')
  //       this.$emit('hidemodal')
  //     }
  //   })
  // }
}
</script>
